module.exports = __webpack_public_path__ + "img/w6.cfcd89b4.webp";